import React from "react";
import ReactDOM from "react-dom";
import Config from "@5tbim/config";
import ExamInformations from "./components/examInformations";
import Resources from "./components/resources";
import ResearchProjectList from "./components/researchProjects";
import TrainClassesList from "./components/trainClasses";
import CarouselImage from "./components/CarouselImage";
import RowContainer from "./components/RowContainer";
import MainLayout from "../mainLayout";
import ExpertContainer from "./components/expertContainer";
import Questionnaires from "./components/questionnaires";
import Activitys from "./components/academicactivity";
import "./components/row.scss";
import "./components/expert.scss";
import "./index.scss";

function IndexPage() {
  return (
    <MainLayout navKey="main">
      <CarouselImage />
      <RowContainer
        title="调研问卷"
        rowStyle={{ background: "#e0e0e0" }}
        more={
          <a
            href={Config.QuestionnaireList}
            target="_blank"
            rel="noopener noreferrer"
          >
            更多>>
          </a>
        }
      >
        <Questionnaires contentStyle={{ height: 140 }} />
      </RowContainer>
      <RowContainer
        title="科研课题"
        rowStyle={{ background: "#f3f1ec" /*background: "#f5f5f5"*/ }}
        more={
          <a
            href={Config.ResearchProjects}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#2F72A8", textDecoration: "underline" }}
          >
            更多>>
          </a>
        }
      >
        <ResearchProjectList />
        <div
          class="wrapcontainer__row__col"
          style={{
            background: "#e0e0e0",
            marginTop: "10px",
            marginLeft: "auto",
          }}
        >
          <div class="contentItem" style={{ marginTop: "-90px" }}>
            <div class="contentItem__content" style={{ height: "auto" }}>
              <div
                class="contentItem__content__title"
                style={{
                  fontSize: "28px",
                  fontWeight: "normal",
                  marginBottom: "40px",
                }}
              >
                课题申报
              </div>
              <div style={{ padding: "10px 10px" }}>
                <div
                  class="contentItem__content__subtitle"
                  style={{ fontSize: "14px", textIndent: "24px" }}
                >
                  《“以竹代塑” 进校园》项目由北京竹事科技集团发起，旨在积极响应习总书记“以竹代塑”全球倡议，加速“以竹代塑”科研成果在校园场景的应用转化，支持“以竹代塑”科学教育及其他相关学科课程研发，鼓励教玩具创意设计和校园文化建设。为了有效促进产学研协同创新，保障《“以竹代塑”进校园项目》的稳步实施，项目组发布系列科研项目。
                  <br />
                  特别邀请普通本科院校、职业类院校、中小学、幼儿园、地方教育管理部门，申报各类课题。
                </div>
              </div>
            </div>
          </div>
        </div>
      </RowContainer>
      <RowContainer
        title="学术活动"
        rowStyle={{ background: "#e0e0e0" }}
        more={
          <a
            href={Config.AcademicList}
            target="_blank"
            rel="noopener noreferrer"
          >
            更多>>
          </a>
        }
      >
        <Activitys />
      </RowContainer>

      <RowContainer
        title="培训项目"
        rowStyle={{
          background: "#e0e0e0",
        }}
        more={
          <a
            href={Config.TrainClasses}
            target="_blank"
            rel="noopener noreferrer"
          >
            更多>>
          </a>
        }
      >
        <TrainClassesList />
        <div
          class="wrapcontainer__row__col"
          style={{
            background: "#f3f1ec",
            marginTop: "10px",
            marginLeft: "auto",
          }}
        >
          <div class="contentItem" style={{ marginTop: "-90px" }}>
            <div class="contentItem__content" style={{ height: "auto" }}>
              <div
                class="contentItem__content__title"
                style={{
                  fontSize: "28px",
                  fontWeight: "normal",
                  marginBottom: "40px",
                }}
              >
                培训师申请
              </div>
              <div style={{ padding: "20px 20px" }}>
                <div
                  class="contentItem__content__subtitle"
                  style={{ fontSize: "14px", textIndent: "24px" }}
                >
                  “以竹代塑”进校园项目诚聘竹产业专家、竹碳汇专家、软件工程师、3D创意设计师、具备各学科“以竹代塑”教育成果的教师、研学指导老师等，加入培训师队伍。共同推进“以竹代塑”教育创新事业。
                  <br />
                  
                </div>
                <div
                  class="contentItem__content__subtitle"
                  style={{ margin: "15px 0 10px 0", textAlign: "center" }}
                >
                  <a
                    className="button bg-blue"
                    style={{
                      height: "30px",
                      width: "160px",
                      display: "inline-block",
                      lineHeight: "30px",
                      margin: "10px 0",
                      fontSize: "16px",
                      borderRadius: 0,
                      textDecoration: "none",
                      marginTop: "30px",
                    }}
                    href={`${Config.UserCenter}${Config.RequestTrainer}`}
                  >
                    申请成为培训师
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </RowContainer>

      <a href={Config.UserRequestList}>
        <div
          style={{
            background: 'url("images/exam-bg.jpg")',
            backgroundSize: "cover",
            color: "#fff",
            display: "flex",
            height: "400px",
          }}
        >
        </div>
      </a>

      <div style={{ display: "flex" }} className="resource">
        <RowContainer
          title="学术论文"
          rowStyle={{ background: "#e0e0e0", width: "50%" }}
          more={
            <a
              href={Config.ResourceList + "?type=infomation"}
              target="_blank"
              rel="noopener noreferrer"
            >
              更多>>
            </a>
          }
        >
          <Resources resourceType="infomation" />
        </RowContainer>
        <RowContainer
          title="行业动态"
          rowStyle={{ background: "#dad9d9", width: "50%" }}
          more={
            <a
              href={Config.ResourceList + "?type=newsCategroy"}
              target="_blank"
              rel="noopener noreferrer"
            >
              更多>>
            </a>
          }
        >
          <Resources resourceType="newsCategroy" />
        </RowContainer>
      </div>

      {/* <RowContainer title="专家导师" rowStyle={{ background: "#f3f1ec" }}>
        <ExpertContainer />
      </RowContainer> */}
    </MainLayout>
  );
}


ReactDOM.render(<IndexPage />, document.getElementById("root"));

if (module.hot) {
  module.hot.accept();
}
